<template>
  <v-container
    id="city-progress"
  >
    <app-city-header
      :payload="payload.municipio"
    >
    </app-city-header>

    <v-row>
      <v-col
        md="12"
        sm="12"
        lg="12"
      >
        <v-alert
          color="primary"
          dense
          class="text-center"
        >
          <span
            class="white--text"
          >
            <h1>
              GERAL
            </h1>
          </span>
        </v-alert>
        <bar-chart
          :chart-data="chartData"
          :options="barChartOptions"
          :width="200"
          :height="200"
        ></bar-chart>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        md="3"
        sm="3"
        lg="3"
        v-for="chart in chartEixoArray"
        v-bind:key="chart.eixo.municipioGrupoSolucaoId"
      >
        <v-alert
          color="primary"
          dense
          class="text-center"
        >
          <span
            class="white--text"
          >
            <h1>
              {{ chart.eixo.nome }}
            </h1>
          </span>
        </v-alert>
        <pie-chart
          :chart-data="chart.chartData"
          :options="chartOptions"
          :width="200"
          :height="200"
        >
        </pie-chart>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-alert
          color="primary"
          dense
          class="text-right"
        >
        </v-alert>

        <v-data-table
          :headers="headers"
          :items="payload.solucaoTarefas"
          item-key="name"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.solucao.status="{ item }">
            <tr>
              <td>A Fazer</td>
              <td style="width: 500px">
                <v-progress-linear
                  color="light-blue"
                  height="10"
                  :value="((item.totalTarefas - item.tarefasCumpridas)/item.totalTarefas) * 100"
                  striped
                ></v-progress-linear>
              </td>
            </tr>

            <tr>
              <td>Concluído</td>
              <td style="width: 500px">
                <v-progress-linear
                  color="light-blue"
                  height="10"
                  :value="(item.tarefasCumpridas/item.totalTarefas) * 100"
                  striped
                ></v-progress-linear>
              </td>
            </tr>

            <tr>
              <td>Total</td>
              <td>
                {{ item.totalTarefas }}
              </td>
            </tr>
          </template>

          <template v-slot:item.solucao.total="{ item }">
            <tr>
              <td>{{ item.totalTarefas - item.tarefasCumpridas }}</td>
            </tr>

            <tr>
              <td>{{ item.tarefasCumpridas }}</td>
            </tr>

            <tr>
              <td>{{ item.totalTarefas }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BarChart from '@/components/chart/BarChart'
import PieChart from '@/components/chart/PieChart'
import { AppCityHeader, cityAPI } from '@/modules/city'
import { mapActions } from 'vuex'

export default {
  components: {
    BarChart,
    PieChart,
    AppCityHeader
  },
  data () {
    return {
      payload: {
        municipio: {
          municipioId: this.$route.params.id,
          nome: ''
        },
        totalTarefas: null,
        totalTarefasCumpridas: null
      },
      chartOptions: {
        hoverBorderWidth: 10
      },
      chartData: {},
      chartEixoArray: [],
      headers: [
        {
          text: 'Solução',
          value: 'municipioSolucao.nome',
          sortable: false
        },
        {
          text: 'Status',
          value: 'solucao.status',
          sortable: false
        },
        {
          text: 'Total Geral',
          value: 'solucao.total',
          sortable: false
        }
      ],
      lineChartOptions: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              suggestedMin: 0
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [ {
            ticks: {
              beginAtZero: true,
              suggestedMin: 0,
              max: 100
            },
            gridLines: {
              display: false
            }
          }]
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false
      },
      barChartOptions: {
        scales: {
          yAxes: [{
            gridLines: {
              display: true
            }
          }],
          xAxes: [ {
            ticks: {
              beginAtZero: true,
              suggestedMin: 0,
              max: 100
            },
            gridLines: {
              display: false
            }
          }]
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    getTasks () {
      this.setLoading(true)
      cityAPI.getTasksReport(this.$route.params.id)
        .then(resp => {
          this.payload = resp.data
          this.setLoading(false)
          this.fillChart(Math.round(((this.payload.totalTarefas - this.payload.totalTarefasCumpridas) / this.payload.totalTarefas) * 100), Math.round((this.payload.totalTarefasCumpridas / this.payload.totalTarefas) * 100))

          for (let count = 0; count < resp.data.eixoTarefas.length; count++) {
            let item = resp.data.eixoTarefas[count]
            if (item.totalTarefas > 0) this.fillAxisChart(item.totalTarefas - item.tarefasCumpridas, item.tarefasCumpridas, item.municipioGrupoSolucao)
          }
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao buscar relatório')
        })
    },
    fillChart (totalACumprir, totalCumprido) {
      this.chartData = {
        labels: ['A FAZER (%)', 'CONCLUÍDO (%)'],
        datasets: [
          {
            backgroundColor: ['#FF5252', '#5C8BB9'],
            data: [totalACumprir, totalCumprido]
          }
        ]
      }
    },
    fillAxisChart (totalACumprir, totalCumprido, eixo) {
      this.chartEixoArray.push({
        eixo: eixo,
        chartData: {
          labels: ['A FAZER', 'CONCLUÍDO'],
          datasets: [
            {
              backgroundColor: ['#FF5252', '#5C8BB9'],
              data: [totalACumprir, totalCumprido]
            }
          ]
        }
      })
    }
  },
  mounted () {
    this.getTasks()
  }
}
</script>

<style lang="scss">@import './style.scss';</style>
